import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "72",
  height: "72",
  viewBox: "0 0 72 72",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "72",
  height: "72",
  transform: "translate(72 72) rotate(-180)",
  fill: "#0B0A0A"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M42.0016 22.9946L42 34.6994L42 37.3005L42.0016 49.0053",
  stroke: "#EFEFEF",
  "stroke-width": "8.12834"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M30.0002 22.9946L29.9985 34.6994L29.9985 37.3005L30.0002 49.0053",
  stroke: "#EFEFEF",
  "stroke-width": "8.12834"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }